// "Descriptions" - the tag RandomDescriptions.tsx's own "add description"
// button pre-selects, same idiom as champis-events' eventsTag.ts. Mirrors
// TagLookup::DESCRIPTIONS_SLUG server-side, but hardcoded here rather than
// resolved from a slug: no JS-side equivalent of that PHP lookup exists,
// and this id is as stable as EVENTS_TAG_ID's own (a champis.net-era tag,
// never renumbered by a migration re-run - see 02_tags.php).
export const DESCRIPTIONS_TAG_ID = 1000060;

// Its required primary parent ("Rédactions") - hardcoded rather than read
// off `Tag.parent()`, since GET /api/tags/{id} doesn't inline the parent
// resource (no `included` section, only a bare relationship identifier).
// Used by RandomDescriptions.tsx to pre-select both tags when starting a
// new description (minPrimaryTags=1 makes the parent mandatory alongside
// the child).
export const DESCRIPTIONS_PARENT_TAG_ID = 1000061;
flarum.reg.add('champis-species', 'forum/utils/descriptionsTag', { DESCRIPTIONS_TAG_ID: DESCRIPTIONS_TAG_ID,DESCRIPTIONS_PARENT_TAG_ID: DESCRIPTIONS_PARENT_TAG_ID, });